<template>
  <div class="active_revisit_wrap">
    <a-spin :spinning="loading">
      <!-- 统计卡片 -->
      <div class="stat_cards" ref="boardRef">
        <StatCards />
      </div>
      <!-- 主体部分 -->
      <div class="main_content">
        <!-- 筛选区 -->
        <div class="searchContainer" ref="searchRef">
          <!-- 左侧 -->
          <div class="filter_base-left">
            <a-select
              v-if="isAdmin"
              v-model:value="query.queryType"
              class="filter_select"
              placeholder="全部回访类型"
              allowClear
              :options="queryTypeOptions"
              @change="onChangePage"
            ></a-select>
            <a-select
              v-else
              v-model:value="query.taskSourceType"
              class="filter_select"
              placeholder="全部任务类型"
              allowClear
              :options="taskTypeOptions"
            ></a-select>
            <a-select
              v-model:value="query.followupStatusList"
              mode="multiple"
              class="filter_select"
              placeholder="全部回访状态"
              allowClear
              :options="followupStatusOptions"
            ></a-select>
            <div v-if="isAdmin">
              <a-select
                v-model:value="filterType"
                class="filter_select"
                style="width: 100px"
                :options="filterTypeOptions"
                @change="handleFilterTypeChange"
              ></a-select>
              <span v-show="filterType === 'department'">
                <a-tree-select
                  style="width: 250px"
                  v-model:value="query.departmentIds"
                  class="filter_select"
                  placeholder="选择部门"
                  multiple
                  :maxTagCount="2"
                  tree-checkable
                  show-checked-strategy="SHOW_PARENT"
                  allowClear
                  :tree-data="departmentTreeData"
                  :replaceFields="{
                    children: 'child',
                    title: 'dptName',
                    key: 'id',
                    value: 'id'
                  }"
                ></a-tree-select>
              </span>
              <a-select
                style="width: 250px"
                v-show="filterType === 'da'"
                v-model:value="query.assignedDaUcUserId"
                class="filter_select"
                placeholder="选择健管"
                mode="multiple"
                :maxTagCount="2"
                :maxTagTextLength="3"
                allowClear
                show-search
                :filter-option="filterDaOption"
                :options="daListOptions"
              ></a-select>
            </div>
            <a-range-picker
              v-model:value="followupDateList"
              class="filter_picker"
              :placeholder="['回访开始时间', '回访结束时间']"
              format="YYYY-MM-DD"
              valueFormat="YYYY-MM-DD"
              :disabled-date="e => disabledDate(e)"
              :ranges="dateRangeOptions"
            />
            <a-range-picker
              v-if="isAdmin"
              v-model:value="assignedDateList"
              class="filter_picker"
              :placeholder="['分配开始时间', '分配结束时间']"
              format="YYYY-MM-DD"
              valueFormat="YYYY-MM-DD"
              :disabled-date="e => disabledDate(e)"
              :ranges="dateRangeOptions"
            />
            <a-range-picker
              v-if="isAdmin"
              v-model:value="lastTouchDateList"
              class="filter_picker"
              :placeholder="['上次触达开始时间', '上次触达结束时间']"
              format="YYYY-MM-DD"
              valueFormat="YYYY-MM-DD"
              :disabled-date="e => disabledDate(e, 3)"
              :ranges="dateRangeOptions"
            />
            <a-select
              v-model:value="query.callStatus"
              class="filter_select"
              placeholder="通话状态"
              allowClear
            >
              <a-select-option :value="1">接通</a-select-option>
              <a-select-option :value="2">未接通</a-select-option>
            </a-select>
            <a-select
              v-model:value="query.conversionScene"
              class="filter_select"
              placeholder="选择转化场景"
              allowClear
              :options="conversionSceneOptions"
            ></a-select>
            <a-select
              v-model:value="query.benefitConversionFlag"
              class="filter_select"
              placeholder="是否达成效益转化"
              allowClear
              :options="benefitConversionFlagOptions"
            ></a-select>
            <a-select
              v-model:value="query.revisitDateFlag"
              class="filter_select"
              placeholder="是否设置复诊日期"
              allowClear
              :options="revisitDateFlagOptions"
            ></a-select>

            <a-input
              v-model:value="query.ucPatientId"
              class="filter_select"
              placeholder="患者ID"
              allowClear
              :maxLength="100"
            />
            <a-input
              v-model:value="query.patientName"
              class="filter_select"
              placeholder="患者姓名"
              allowClear
              :maxLength="100"
            />
            <a-input
              v-model:value="query.patientPhone"
              class="filter_select"
              placeholder="患者手机号"
              allowClear
              :maxLength="20"
            />
          </div>
          <!-- 搜索按钮 -->
          <div class="search_btns">
            <a-button class="btn" @click="resetQuery">重置</a-button>
            <a-button class="btn" type="primary" @click="onChangePage">搜索</a-button>
          </div>
        </div>

        <!-- 列表区 -->
        <div class="data_wrap" ref="tableRef">
          <div class="followup-legend">
            <div
              v-for="item in followupLegend"
              :key="item.label"
              class="followup-legend-item"
              @click="switchFollowupStatus(item.value)"
            >
              <span class="followup-legend-color" :style="item.style">
                <CheckOutlined
                  :style="{ fontSize: '10px' }"
                  v-show="item.value === query.queryType"
                />
              </span>
              <span>{{ item.label }}</span>
            </div>
          </div>

          <a-table
            class="table"
            :pagination="pagination"
            rowKey="id"
            :columns="columns"
            :data-source="tableData"
            @change="onChangePage"
            :transformCellText="({ text }) => text ?? '--'"
            :scroll="{ x: 100, y: `calc(100vh - ${sHeight}px - 165px)` }"
            :rowClassName="rowClassName"
          >
            <template #patientName="{ record }">
              <a-button
                class="table_item"
                size="small"
                type="link"
                @click="handlePatientClick(record)"
              >
                {{ record.patientName || '--' }}
              </a-button>
            </template>
            <template #boundDoctorNum="{ record }">
              <a-button
                class="table_item"
                size="small"
                type="link"
                @click="goPatientBindDoc(record)"
              >
                {{ record.boundDoctorNum || '--' }}
              </a-button>
            </template>
            <template #patientPhone="{ record }">
              <span class="table_item patient_phone" v-if="record.patientPhone">
                {{ record.patientPhone }}
              </span>
              <span v-else class="table_item patient_phone">--</span>
            </template>

            <template #daName="{ record }">
              <div class="table_item">
                <span class="manager_name">{{ record.daName || '--' }}</span>
                <a-tooltip
                  :overlayStyle="{ maxWidth: '350px' }"
                  overlayClassName="daName-tooltip"
                  placement="topLeft"
                  :title="getAssignTooltip(record)"
                  :getPopupContainer="() => tableRef"
                  v-if="record.assignedByCurrentUser || record.assignedName"
                >
                  <div class="assign_tag_wrap">
                    <a-tag
                      class="tag"
                      color="rgba(31, 181, 171, 0.08)"
                      v-if="record.assignedByCurrentUser"
                    >
                      我分配
                    </a-tag>
                    <QuestionCircleFilled class="icon" />
                  </div>
                </a-tooltip>
              </div>
            </template>
            <template #followupStatusName="{ record }">
              <span class="table_item">
                {{ record.followupStatusName || '--' }}
                <a-tooltip
                  v-if="record.followupStatus === 5"
                  placement="bottomLeft"
                  :title="`移除人:${record.removedName} ${record.removedAt}`"
                  :getPopupContainer="() => tableRef"
                  overlayClassName="my-tooltip"
                >
                  <QuestionCircleFilled
                    class="icon"
                    :style="{ color: '#ccc', marginLeft: '6px' }"
                  />
                </a-tooltip>
              </span>
            </template>
            <template #lastTouchAt="{ record }">
              <div class="table_item reach_time_cell">
                <span>
                  {{ record.lastTouchAt || '--' }}
                </span>
                <!-- 工单类型 -->
                <span class="reach_type_btn">{{ record.lastTouchWorkOrderType }}</span>
                <!-- 打开通话记录 -->
                <auth-img
                  class="img"
                  @click="handleCallRecord({ chatSummaryId: record.lastTouchChatSummaryId })"
                  v-if="record.lastTouchChatSummaryId"
                  :src="callIcon2"
                />
              </div>
            </template>
            <template #operation="{ record }">
              <div v-if="record.showNoAction">--</div>
              <div v-else class="table_item">
                <template v-for="btn in operationButtons" :key="btn.key">
                  <a-button
                    class="link-button"
                    v-if="btn.visible(record)"
                    size="small"
                    type="link"
                    @click="handlers[btn.key](record)"
                  >
                    {{ btn.label }}
                  </a-button>
                </template>
              </div>
            </template>
          </a-table>
        </div>
      </div>
      <!-- 沟通小结弹窗 -->
      <EditSummary ref="editSummaryRef" />
      <!-- 通话弹窗 -->
      <CallModal ref="callModalRef">
        <template #footerBtn="{ record }">
          <a-button
            v-if="record?.showRemove"
            danger
            class="remove-btn"
            @click="handleRemove(record)"
          >
            移除回访池
          </a-button>
        </template>
      </CallModal>
      <!-- 用户池详情 -->
      <Details ref="detailsRef" />
      <FullText ref="FullTextRef" />
      <!-- 补充弹窗 -->
      <RevisitPath ref="revisitPathRef" @action="handleRevisitPath" />
      <!-- 完成回访 / 补充下次回访时间弹窗 -->
      <FollowupCompleteModal ref="followupCompleteModalRef" @success="searchList" />
      <!-- 复诊预约详情 -->
      <ADetail ref="aDetail" :recordId="appointId" />
      <!-- 处方详情 -->
      <TheDetail
        v-model:visible="prescription.visible"
        :id="prescription.id"
        :serialNumber="prescription.serialNumber"
        :recordType="prescription.recordType"
      />
      <!-- 沟通小结展示 -->
      <a-modal
        title="沟通小结"
        :visible="summaryPanelVisible"
        @cancel="summaryPanelVisible = false"
        width="1059px"
        :footer="null"
        :destroyOnClose="true"
        :maskClosable="false"
        :bodyStyle="{
          padding: 0,
          paddingTop: '20px'
        }"
      >
        <SummaryPannel
          :chatSummaryId="chatSummaryId"
          @closeSummaryModal="closeSummaryModal"
          :active="summaryActive"
        />
      </a-modal>
      <CommunicationModal ref="communicationModal" />
    </a-spin>
  </div>
</template>

<script>
export default { name: 'activeRevisit' }
</script>

<script setup>
import CommunicationModal from '@/components/CommunicationModal/index.vue'
import callIcon2 from '@/assets/img/chat/callIcon2.png'
import TheDetail from '@/components/TheDetail/index.vue'
import ADetail from '@/views/WorkPlace/components/Appoint/index.vue'
import EditSummary from '@/views/WorkPlace/Container/Summary/editSummary.vue'
import FullText from '@/components/FullText/index.vue'
import CallModal from '@/components/CallModal/index.vue'
import useRevisitPoolGuard from '@/hooks/useRevisitPoolGuard'
import { reactive, ref, onMounted, computed, nextTick, onActivated, watch } from 'vue'
import { Modal } from 'ant-design-vue'
import { CheckOutlined } from '@ant-design/icons-vue'
import {
  // DownOutlined,
  ExclamationCircleOutlined,
  QuestionCircleFilled
} from '@ant-design/icons-vue'
import {
  columns,
  paginationConfig,
  defaultQuery,
  operationButtons,
  dateRangeOptions,
  queryTypeOptions,
  followupStatusOptions,
  conversionSceneOptions,
  benefitConversionFlagOptions,
  revisitDateFlagOptions,
  filterTypeOptions,
  disabledDate,
  taskTypeOptions,
  followupLegend
} from './config'
import {
  getActiveFollowupPage,
  getDaList,
  getDepartmentTree,
  removeActiveFollowup
} from '@/api/UserPool/activeRevisit'
import { message as Message } from 'ant-design-vue'
import Details from '@/views/UserPool/components/Details/index.vue'
import StatCards from './components/StatCards.vue'
import RevisitPath from './components/RevisitPath.vue'
import FollowupCompleteModal from './components/FollowupCompleteModal.vue'

import { useStore } from 'vuex'
import { useSummary } from '@/hooks/useSummary'
import { createVNode } from 'vue'
import SummaryPannel from '@/views/WorkPlace/Container/chat/components/summaryPannel/index.vue'
import moment from 'moment'
const store = useStore()
const loading = ref(false)

const tableRef = ref(null)
const FullTextRef = ref(null)
const daListOptions = ref([])
// 部门/健管 筛选类型：department-部门 da-健管
const filterType = ref('department')
const departmentTreeData = ref([])
const appointId = ref('')
const aDetail = ref('')
const communicationModal = ref()
// 处方详情
const prescription = ref({
  visible: false,
  id: '',
  serialNumber: '',
  recordType: 'prescriptionGroup'
})

// 使用从 config 导出的默认查询项
const assignedDateList = ref([])
const followupDateList = ref([])
const lastTouchDateList = ref([])
const query = reactive({ ...defaultQuery })
const pagination = reactive({ ...paginationConfig })
const tableData = ref([])
const callModalRef = ref(null)
const detailsRef = ref()

const revisitPathRef = ref(null)
const followupCompleteModalRef = ref(null)
const {
  editSummaryRef,
  summaryActive,
  chatSummaryId,
  summaryPanelVisible,
  handleSummary,
  onCreateSummary,
  closeSummaryModal
} = useSummary(searchList)
const sHeight = ref(0)
// 计算属性 ==============
const isAdmin = computed(() => store.state.user.isAdmin)
const ucUserId = computed(() => store.state.user.userInfo.ucUserId)
const _followupLegend = computed(() => {
  if (isAdmin.value) {
    return followupLegend
  } else {
    return followupLegend.filter(it => it.label !== '我分配的')
  }
})
const switchFollowupStatus = key => {
  query.queryType = key
  onChangePage()
}
// 查询条件逻辑===================
function resetQuery() {
  Object.assign(query, defaultQuery)
  filterType.value = 'department'
  assignedDateList.value = []
  followupDateList.value = []
  lastTouchDateList.value = []
  onChangePage()
}
const patientFileStatus = computed(() => store.state.patientFile.status)
// 患者档案弹窗显示状态有变更需要同步更新回访池数据
watch(
  () => patientFileStatus.value,
  () => {
    searchList()
  }
)
async function fetchDaList() {
  daListOptions.value = []
  try {
    const result = await getDaList()
    daListOptions.value = result.map(m => {
      return {
        ...m,
        label: m.realName,
        value: m.ucUserId
      }
    })
  } catch (error) {
    console.error('获取健管列表失败', error)
  }
}

async function fetchDepartmentTree() {
  departmentTreeData.value = []
  try {
    const result = await getDepartmentTree()
    departmentTreeData.value = result?.child || []
  } catch (error) {
    console.error('获取部门树失败', error)
  }
}

// 切换部门/健管类型时，清空另一侧的已选值
const handleFilterTypeChange = type => {
  if (type === 'department') {
    query.assignedDaUcUserId = []
  } else {
    query.departmentIds = []
  }
}

const filterDaOption = (input, option) => {
  return option.realName.indexOf(input) >= 0
}

async function searchList() {
  loading.value = true
  try {
    // 将日期数组转换为独立的起止时间字段，并补充时分秒
    const payload = {
      ...query,
      pageNo: pagination.current,
      pageSize: pagination.pageSize
    }

    // 部门/健管筛选为纯前端切换：只传当前类型对应的字段
    if (filterType.value === 'department') {
      delete payload.assignedDaUcUserId
    } else {
      delete payload.departmentIds
    }

    // 回访时间范围
    if (followupDateList.value?.[0]) {
      payload.followupStartAt = `${followupDateList.value[0]} 00:00:00`
    }
    if (followupDateList.value?.[1]) {
      payload.followupEndAt = `${followupDateList.value[1]} 23:59:59`
    }

    // 分配时间范围
    if (assignedDateList.value?.[0]) {
      payload.assignedStartAt = `${assignedDateList.value[0]} 00:00:00`
    }
    if (assignedDateList.value?.[1]) {
      payload.assignedEndAt = `${assignedDateList.value[1]} 23:59:59`
    }

    // 上次触达时间范围
    if (lastTouchDateList.value?.[0]) {
      payload.lastTouchStartAt = `${lastTouchDateList.value[0]} 00:00:00`
    }
    if (lastTouchDateList.value?.[1]) {
      payload.lastTouchEndAt = `${lastTouchDateList.value[1]} 23:59:59`
    }
    const result = await getActiveFollowupPage(payload)
    const list = result?.list || []
    const total = result?.totalCount || 0
    tableData.value = list
    pagination.total = total
  } catch (error) {
    console.error('获取主动回访分页失败', error)
    tableData.value = []
    pagination.total = 0
  } finally {
    loading.value = false
  }
}
const onChangePage = (page, _, sorter) => {
  pagination.current = page?.current || 1
  pagination.pageSize = page?.pageSize || 10
  query.sortField = null
  query.sortOrder = null
  // 排序字段：回访时间，lastTouchAt-上次触达时间，boundDoctorNum-绑定医生数
  if (sorter?.order) {
    query.sortField = sorter?.field
    query.sortOrder = sorter?.order === 'ascend' ? 'asc' : 'desc'
  }
  searchList()
}
// 表格逻辑====================
const getAssignTooltip = record => {
  const { assignedByCurrentUser, assignedName, assignedAt } = record
  const date = moment(assignedAt).format('YYYY-MM-DD HH:mm')
  return assignedByCurrentUser ? `我分配的 ${date}` : `健管-${assignedName}分配    ${date}`
}

// 处理行样式
const rowClassName = record => {
  const { assignedByCurrentUser, assignType, daUcUserId } = record
  const isCurrentUser = daUcUserId === ucUserId.value
  if (assignedByCurrentUser) {
    //我分配的
    return 'table-striped-1'
  } else if (assignType === 1 && isCurrentUser) {
    // 我自己加入的
    return 'table-striped-2'
  } else if (assignType === 2 && isCurrentUser) {
    // 分配给我的
    return 'table-striped-3'
  } else {
    return ''
  }
}

// 表格中的可操作项 ===============
const handlePatientClick = record => {
  // console.log('点击患者名称', record)
  const { patientId, doctorId, patientType } = record
  const param = {
    patientId: patientId,
    patientType: patientType,
    doctorId: doctorId
  }
  store.dispatch('patientFile/openModal', param)
}
// 打开拨打电话弹窗
const handleCall = record => {
  // 修改patientId优先取值，要不然useRevisitPoolGuard needConfirm都是false promptType非1
  const patientId = record.ucPatientId || record.patientId || null
  if (patientId) {
    const openCallModal = crossPoolParams => {
      callModalRef.value?.init(record, 1, crossPoolParams)
    }
    // 拨打前先校验是否已在回访任务池中（非结束态），在池中先弹重复联系提醒再进入原 CallModal 流程
    useRevisitPoolGuard({
      ucPatientId: patientId,
      source: 'activeRevisit',
      onPass: openCallModal,
      onContinue: openCallModal
    })
  }
}
// 下钻患者绑定医生详情
const goPatientBindDoc = row => {
  const { boundDoctorNum } = row
  if (!boundDoctorNum) return
  row.mode = 'patient'
  detailsRef?.value?.initModal(row)
}

const handleFullText = record => {
  const { cdrId } = record
  FullTextRef.value?.openModal?.(cdrId)
}
// 移除回访记录
const handleRemove = record => {
  Modal.confirm({
    icon: createVNode(ExclamationCircleOutlined),
    title: '提醒',
    content: `确认将 ${record.patientName || record.nickName} 患者移除任务池？`,
    okText: '确认移除',
    cancelText: '取消',
    onOk() {
      removeActiveFollowup({ followupIds: [record.id] })
        .then(() => {
          Message.success('移除成功')
          searchList()
        })
        .catch(error => {
          // console.error('移除回访记录失败', error)
          // Message.error((error && error.message) || '移除失败')
        })
    }
  })
}

const handlePath = record => {
  revisitPathRef.value.initModal(record)
}
// 完成回访
const handleComplete = record => {
  followupCompleteModalRef.value?.initComplete(record)
}
// 补充下次回访时间
const handleFillNextFollowupTime = record => {
  followupCompleteModalRef.value?.initNextTime(record)
}
// 查看通话记录
const handleCallRecord = record => {
  // callStatus: Integer
  // 通话状态：1接通，2未接通，仅通话路径返回。
  const { callStatus = 1 } = record
  if (callStatus === 1) {
    summaryPanelVisible.value = true
    chatSummaryId.value = record.chatSummaryId
    summaryActive.value = 2
  } else {
    const params = {
      ucPatientId: record.actionPatientType ? record.actionPatientId : null,
      prePatientId: record.actionPatientType === 0 ? record.actionPatientId : null,
      actionPatientType: record.actionPatientType,
      cdrId: record.businessId,
      showSearch: false
    }
    communicationModal.value.openModal(params)
  }
}

// 查看预约单
const handleAppointment = record => {
  const { reserveId } = record
  appointId.value = reserveId
  nextTick(() => {
    aDetail.value.mVisible = true
    aDetail.value.initDetail()
  })
}

// 打开处方详情
const handleRevisit = record => {
  const { serialNumber } = record
  prescription.value.serialNumber = serialNumber
  prescription.value.visible = true
}

// 表格操作策略
const handlers = {
  onCreateSummary,
  handleCall,
  handleRemove,
  handleFullText,
  handlePath,
  handleSummary,
  handleComplete,
  handleFillNextFollowupTime
}
// 详情操作策略
const handleRevisitPath = data => {
  const { path } = data
  const { actionType, actionBusinessId } = path
  // 映射
  const form = {
    chatSummaryId: actionBusinessId,
    serialNumber: actionBusinessId,
    reserveId: actionBusinessId,
    ...path
  }
  const mapFun = {
    1: handleCallRecord,
    2: handleRevisit,
    3: handleAppointment
  }
  const handler = mapFun[actionType]
  if (!handler) {
    console.warn(`未识别的回访路径 actionType: ${actionType}`)
    return
  }
  handler(form)
}
const boardRef = ref(null)
const searchRef = ref(null)
const getHeight = () => {
  nextTick(() => {
    sHeight.value = boardRef?.value?.clientHeight + searchRef?.value?.clientHeight + 100
  })
}
// keep-alive 缓存：页面重新展示重新获取数据
onActivated(() => {
  searchList()
})
onMounted(() => {
  fetchDaList()
  fetchDepartmentTree()
  searchList()
  getHeight()
})
</script>

<style scoped lang="scss">
@import './table-style.scss';

.active_revisit_wrap {
  height: 100%;
  .main_content {
    padding: 16px;
    height: calc(100% - 170px);
    overflow: hidden;
    // 列表区
    .data_wrap {
      // overflow: auto;
      // height: calc(100% - 100px);
      background-color: #fff;
      border-radius: 4px;
      padding: 16px 16px 0;
      .followup-legend {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        margin-bottom: 12px;
        gap: 16px;
        margin-left: auto;
        .followup-legend-item {
          display: flex;
          align-items: center;
          gap: 6px;
          font-size: 12px;
          color: #00000099;
          cursor: pointer;
        }
        .followup-legend-color {
          flex-shrink: 0;
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }
    }
  }
}

// 筛选区
.searchContainer {
  background-color: #fff;
  padding: 12px 16px;
  border-radius: 4px;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .filter_base-left {
    display: flex;
    align-items: center;
    gap: 12px;
    flex-wrap: wrap;
    .filter_select {
      width: 223px;
    }
    .filter_picker {
      width: 240px;
    }
  }

  .search_btns {
    display: flex;
    justify-content: flex-end;
    gap: 8px;
  }
}

::v-deep(.my-tooltip) {
  width: 270px;
  max-width: 270px;
  .ant-tooltip-inner {
    padding: 8px 16px;
  }
}
// 黑色弹出的提示内容框 样式
::v-deep(.daName-tooltip) {
  .ant-tooltip-content {
    .ant-tooltip-inner {
      min-width: 200px;
      border-radius: 4px;
    }
  }
}
</style>
